const LineBreakContainer = (props) => {
  return (
    <div { ...props } style={ { 'whiteSpace': 'pre-line' } }>
      { props.children }
    </div>
  );
}

export default LineBreakContainer;
